<template>
  <div v-if="showForm" :class="{ 'form-class': true, 'rlt-class': initData.alignment === '2' }">
    <a-spin :spinning="spinning">
      <PcForm
        v-if="isPC"
        :initData="initData"
        :routeData="routeData"
        :disabled="disabled"
        :isPreview="isPreview"
      />
      <div :class="{ 'app-content': isPreview }" v-else>
        <AppForm :initData="initData" :routeData="routeData" :disabled="disabled || isPreview" />
      </div>
    </a-spin>
  </div>
  <a-result v-if="showResult" status="404" :sub-title="subTitle"></a-result>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import PcForm from './components/PcForm.vue'
import AppForm from './components/AppForm.vue'
import {
  GetFormTemplateDetail,
  GetRegisterInfo,
  GetEditable
} from '@/services/marketing-management/form-management'

const props = defineProps({
  previewData: {
    type: Object,
    required: true,
    default: () => ({})
  },
  type: {
    type: String,
    default: '2',
    required: false
  },
  isPreview: {
    required: true,
    type: Boolean,
    default: false
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const isPC = ref(true)
const showForm = ref(false)
const showResult = ref(false)
const initData = ref({})
const routeData = ref({})
const baseInfo = ref({})
const disabled = ref(props.disabled)
const spinning = ref(true)
const subTitle = ref('')

const getUrlQuery = address => {
  var url = address.split('?')[1] //获取url中"?"符后的字串
  if (!url) return ''
  var theRequest = new Object()
  var str = url.substr(0)
  var strs = str.split('&')
  for (var i = 0; i < strs.length; i++) {
    theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
  }
  return theRequest
}

// 生成唯一uid
const getRandomNumber = () => {
  let randomNumber = localStorage.getItem('formUid')
  if (!randomNumber) {
    randomNumber = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
    localStorage.setItem('formUid', randomNumber)
  }
  return randomNumber
}

const baseInfoBackfill = (data: any) => {
  const { city, companyName, firstName, lastName, phone } = data
  initData.value.filedList.forEach(item => {
    if (item.systemType && !item.fieldValue) {
      switch (item.systemType) {
        // case '1':
        //   item.fieldValue = country ? country : undefined
        //   break
        // case '2':
        //   item.fieldValue = state ? state : undefined
        //   break
        case '3':
          item.fieldValue = city ? city : undefined
          break
        case '4':
          item.fieldValue = companyName ? companyName : undefined
          break
        case '5':
          item.fieldValue = firstName ? firstName : undefined
          break
        case '6':
          item.fieldValue = lastName ? lastName : undefined
          break
        case '7':
          item.fieldValue = routeData.value.email ? routeData.value.email : undefined
          break
        case '8':
          item.fieldValue = phone ? phone : undefined
          break
        default:
          break
      }
    }
  })
}

const safeDecodeURIComponent = (encodedURI: any) => {
  let modifiedURI = encodedURI.replace(/\+/g, '%20')
  return decodeURIComponent(modifiedURI)
}

const isMobile = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  // 检查用户代理字符串中的关键字
  if (/android/i.test(userAgent)) {
    return true // Android设备
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true // iOS设备
  }
  return false // 不是移动设备
}

onMounted(async () => {
  const innerWidth = window.innerWidth || 0
  if (innerWidth >= 1000) {
    isPC.value = true
  } else {
    isPC.value = false
  }
  if (props.isPreview) {
    initData.value = props.previewData
    showForm.value = true
    spinning.value = false
  } else {
    let {
      templateId,
      verifyCode,
      trainingId,
      trainingEventSessionId,
      email,
      code,
      surveyCode,
      failMsg
    } = getUrlQuery(window.location.href)
    if (failMsg) {
      showResult.value = true
      subTitle.value = safeDecodeURIComponent(failMsg)
      return
    }

    if (!verifyCode) {
      const params1 = {
        trainingId,
        email,
        code,
        sessionId: trainingEventSessionId,
        muchSession: trainingEventSessionId ? '1' : '0'
      }
      const { data } = await GetRegisterInfo(params1)
      baseInfo.value = data
    }
    let deviceSourceType = '02'
    if (code) {
      deviceSourceType = isMobile() ? '03' : '01'
    }
    const params = {
      templateId,
      verifyCode,
      trainingId,
      surveyCode,
      deviceSourceType,
      createdBy: getRandomNumber(),
      templateType: verifyCode ? '2' : '1',
      code,
      trainingMemberId: baseInfo.value.memberId ? baseInfo.value.memberId : undefined
    }
    const { data } = (await GetFormTemplateDetail(params)) || {}
    routeData.value = {
      templateId,
      verifyCode,
      trainingId,
      trainingEventSessionId,
      email,
      templateType: verifyCode ? '2' : '1',
      deviceSourceType: verifyCode ? deviceSourceType : undefined,
      code,
      surveyCode,
      trainingMemberId: baseInfo.value.memberId ? baseInfo.value.memberId : undefined
    }
    data.filedList = data.filedList.map(item => {
      if (['3', '4', '5', '8'].includes(item.fieldType) && item.fieldValue && !item.systemType) {
        item.fieldValue = JSON.parse(item.fieldValue)
      }
      return item
    })
    initData.value = data
    if (!verifyCode) {
      baseInfoBackfill(baseInfo.value)
      const params = {
        trainingId,
        sessionId: trainingEventSessionId,
        muchSession: !!trainingEventSessionId,
        trainingMemberId: baseInfo.value.memberId ? baseInfo.value.memberId : undefined
      }
      const { data } = await GetEditable(params)
      disabled.value = data
    }
    showForm.value = true
    spinning.value = false
  }
})

watch(
  () => props.type,
  value => {
    if (props.type === '1') {
      isPC.value = false
    }
    if (props.type === '2') {
      isPC.value = true
    }
  }
)
</script>

<style lang="less" scoped>
.form-class {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.app-content {
  width: 396px;
  height: 836px;
  padding: 40px 12px 12px;
  margin: 0 auto;
  border-radius: 40px;
  background: url(../../assets/images/form/iPhone.svg) #fff;
  :deep(.app-form) {
    background-color: transparent;
  }
}
.ant-result {
  height: 100vh;
  padding-top: 20vh;
}
.rlt-class {
  direction: rtl;
  :deep(.form-pc) {
    .header-title,
    .header-subtitle,
    .disclaimer-class {
      text-align: right;
    }
    .ant-form-item-label {
      label {
        float: right;
        &::before {
          left: -10px;
        }
      }
    }
    .ant-input-textarea::after {
      float: left;
    }
    .ant-form-item-explain-error {
      float: right;
    }
    .ant-picker-input {
      .ant-picker-suffix {
        margin-left: 0;
      }
    }
    .ant-select {
      .ant-select-selection-placeholder,
      .ant-select-selection-item {
        text-align: right;
        padding-right: 0;
      }
      .ant-select-arrow,
      .ant-select-clear {
        right: unset;
        left: 11px;
      }
      .ant-select-selection-search {
        right: 10px;
      }
    }
    .ant-picker-clear {
      right: unset;
      left: 0;
    }
    .ant-select-item-option-content {
      text-align: right;
    }
    .footer-class,
    .agreement-class {
      display: flex;
      gap: 4px;
    }
    .pickerClass {
      left: unset !important;
      right: 0;
    }
    .ant-table-cell {
      text-align: right;
    }
    .ant-rate {
      .ant-rate-star-first {
        min-height: 24px;
        left: unset !important;
        right: 0;
      }
    }
  }
  :deep(.app-form) {
    .app-form-title,
    .app-form-subtitle,
    .disclaimer-class {
      text-align: right;
    }
    .van-field__control {
      text-align: right;
    }
    .van-field__word-limit {
      text-align: left;
    }
    .van-rate {
      gap: 36px;
      .van-rate__item {
        margin: 0;
      }
    }
  }
}
</style>
